import { render, staticRenderFns } from "./2025-10-27.vue?vue&type=template&id=91f58018&scoped=true&"
import script from "./2025-10-27.vue?vue&type=script&lang=js&"
export * from "./2025-10-27.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f58018",
  null
  
)

export default component.exports